import { render, staticRenderFns } from "./LookInfoDialog.vue?vue&type=template&id=1194960c&scoped=true"
import script from "./LookInfoDialog.vue?vue&type=script&lang=js"
export * from "./LookInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194960c",
  null
  
)

export default component.exports